import React from "react";
import { Dialog } from "../../../dialog";

export default function OptionDialog({ t, children }) {
    return (
        <Dialog className="option" titleKey={t("dialog.option")} width="300">
            { children }
        </Dialog>
    )
}